<template>
    <div class="container-admin">
        <div class="filter-container">
            <div class="filter">
                <label for="filter-by">Vertrag</label>
                <select v-model="selectedFilter" id="filter-by">
                    <option value="active">Zur Zeit laufende Verträge</option>
                    <option value="all">Alle Verträge</option>
                    <option value="closed">Inaktive Verträge</option>
                </select>
            </div>
            <div class="filter">
                <label for="filter-user">Mitarbeiter</label>
                <select v-if="getUserData() != null" v-model="userFilter" id="filter-user">
                    <option value="all">Alle Nutzer</option>
                    <option v-for="(user, index) in getUserData().allUsers" :key="index">
                        {{ user }}
                    </option>
                </select>
            </div>
            <CreateModal v-if="isCreateModalVisible" title="Add Contract" :show="isCreateModalVisible"
                @close="closeCreateModal" @update="loadContracts">
            </CreateModal>
            <UpdateModal v-if="isUpdateModalVisible" title="Update Contract" :show="isUpdateModalVisible"
                :latestUpdate="latestUpdate" @close="closeUpdateModal" @update="loadContracts">
            </UpdateModal>
            <DeleteModal v-if="isDeleteModalVisible" title="Delete Contract" :show="isDeleteModalVisible"
                :latestDelete="latestDelete" @close="closeDeleteModal" @update="loadContracts">
            </DeleteModal>
            <TerminateModal v-if="isTerminateModalVisible" title="Terminate Contract" :show="isTerminateModalVisible"
                :latestTerminate="latestTerminate" @close="closeTerminateModal" @update="loadContracts">
            </TerminateModal>
            <SickDaysModal v-if="isSickDaysModalVisible" :show="isSickDaysModalVisible" :contractId="sickDaysOptions.contractId" :employeeName="sickDaysOptions.employeeName" @update="loadContracts" @close="closeSickDaysModal" />
            <div class="contract-button">
                <button class="btn-update btn-right" @click="sendSickDaysSummary">Übersicht Krankheitstage per Email versenden</button>
            </div>
            <div class="contract-button">
                <button class="btn-update btn-right" @click="openCreateModal">Vertrag hinzufügen</button>
            </div>
        </div>
        <table class="table">
            <tr>
                <th>ID</th>
                <th v-if=showUsers()>Nutzer</th>
                <th>Vertrag Beginn</th>
                <th>Vertrag Ende</th>
                <th>Wochenstunden <span class="sub">h</span></th>
                <th>Soll Zeit <span class="sub">h</span></th>
                <th>Ist Zeit <span class="sub">h</span></th>
                <th>Tage Krank</th>
                <th>Urlaubstage</th>
                <th>Zeit Differenz <span class="sub">h</span></th>
                <th>Funktionen</th>
            </tr>
            <tr v-for="(contract, index) in filteredContracts" :key="index">
                <td class="display-right">{{ contract.contractId }}</td>
                <td v-if=showUsers()>{{ contract.user }}</td>
                <td class="display-right">{{ contract.contractStart }}</td>
                <td :class="{'display-right': contract.contractEnd != 'offen'}">{{ contract.contractEnd }}</td>
                <td class="display-right">{{ contract.weeklyWorkHours }}</td>
                <td class="display-right">{{ contract.targetTime.toFixed(2) }}</td>
                <td class="display-right">{{ contract.actualTime.toFixed(2) }}</td>
                <td class="display-right">{{ contract.daysIll }} ({{ hoursIll(contract.daysIll, contract.weeklyWorkHours).toFixed(2) }}h)</td>
                <td class="display-right">{{ contract.holidays }} </td>
                <td class="display-right" :class="{ 'timeRed': contract.timeDifference < 0, 'timeGreen': contract.timeDifference >= 0 }">
                    {{ contract.timeDifference.toFixed(2) }}
                </td>
                <td v-if="contract.isClosed === false && contract.contractEnd === 'offen'" class="button-footer">
                    <button class="btn-update btn-right" @click="this.latestUpdate = contract; openUpdateModal()">Update</button>
                    <button class="btn-update btn-right"
                        @click="this.latestTerminate = contract; openTerminateModal()">Terminieren</button>
                    <button class="btn-update btn-right" @click="openSickDaysModal(contract.contractId, contract.user)">Krankheitstage</button>
                </td>
                <td v-else-if="contract.isClosed === false && contract.contractEnd != 'offen'"
                    class="button-footer">
                    <button class="btn-update btn-right" @click="this.latestUpdate = contract; openUpdateModal()">Update</button>
                </td>
                <td v-else class="button-footer">
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import apiService from '@/service';
import CreateModal from './CreateModal.vue';
import UpdateModal from './UpdateModal.vue';
import DeleteModal from './DeleteModal.vue';
import TerminateModal from './TerminateModal.vue';
import SickDaysModal from './SickDaysModal.vue';
export default {
    components: {
        CreateModal,
        UpdateModal,
        DeleteModal,
        TerminateModal,
        SickDaysModal
    },
    name: "AdminComponent",
    data() {
        return {
            contractsArray: [],
            selectedFilter: "active",
            listUsers: null,
            userFilter: "all",
            latestUpdate: [],
            latestDelete: [],
            latestTerminate: [],
            isCreateModalVisible: false,
            isUpdateModalVisible: false,
            isDeleteModalVisible: false,
            isTerminateModalVisible: false,
            isSickDaysModalVisible: false,
            isLoggedIn: false,
            sickDaysOptions: {
                contractId: -1,
                employeeName: ''
            }
        };
    },
    mounted() {
        if (localStorage.getItem("isLoggedIn") != "true") {
            this.$router.push("/");
            return;
        }
        this.isLoggedIn = localStorage.getItem("isLoggedIn");
        this.loadContracts();
    },
    methods: {
        loadContracts() {
            apiService
                .get(`/ContractAdmin/GetAllContracts`)
                .then((response) => {
                    this.contractsArray = response.data.map((item) => ({
                        user: item.user,
                        contractStart: new Intl.DateTimeFormat("de-DE", {month:'2-digit',day:'2-digit', year:'numeric'}).format(new Date(item.contractStart)),
                        contractEnd: item.contractEnd != null ? new Intl.DateTimeFormat("de-DE", {month:'2-digit',day:'2-digit', year:'numeric'}).format(new Date(item.contractEnd)) : "offen",
                        weeklyWorkHours: item.weeklyWorkHours,
                        targetTime: item.targetTime,
                        actualTime: item.actualTime,
                        timeDifference: item.timeDifference,
                        daysIll: item.daysIll,
                        holidays: item.holidays,
                        contractId: item.contractId,
                        isClosed: item.isClosed,
                    }));
                })
                .catch((error) => {
                    console.log("OutputTimes error:", error);
                })
                .finally(() => {
                    console.log("OutputTimes finally:");
                });
        },
        filterContracts() {
            let filteredContracts
            if (this.selectedFilter === "active") {
                filteredContracts = this.contractsArray.filter((contract) => contract.contractEnd === "offen" || new Date(contract.contractEnd.split(".").reverse().join(".")) >= new Date());
            } else if (this.selectedFilter === "all") {
                filteredContracts = this.contractsArray;
            } else if (this.selectedFilter === "closed") {
                filteredContracts = this.contractsArray.filter((contract) =>  new Date(contract.contractEnd.split(".").reverse().join(".")) <= new Date());
            }
            if (this.userFilter !== "all") {
                filteredContracts = filteredContracts.filter((contract) => {
                    if (this.getUserData() != null) {
                        this.listUsers = this.getUserData().allUsers;
                        const userIndex = this.listUsers.indexOf(this.userFilter);
                        return contract.user === this.getUserData().allUsers[userIndex];
                    }
                    return contract.user === null;
                });
            }
            return filteredContracts;
        },
        isDateAfterToday(date) {
            const regexpSize = /^(?<Day>[0-9]+)\.(?<Month>[0-9]+)\.(?<Year>[0-9]+)$/;
            const match = date.match(regexpSize);
            return new Date(match.groups.Year, match.groups.Month, match.groups.Day) > this.getDateThreeMonthsBeforeToday();
        },
        getDateThreeMonthsBeforeToday() {
            let day = new Date();
            day.setMonth(day.getMonth() - 2);
            return day
        },
        hoursIll(daysIll, weeklyWorkHours) {
            return daysIll * (weeklyWorkHours / 5)
        },
        getUserData() {
            var jsonString = localStorage.getItem('userData');
            return jsonString ? JSON.parse(jsonString) : null;
        },
        openCreateModal() {
            this.isCreateModalVisible = true;
        },
        closeCreateModal() {
            this.isCreateModalVisible = false;
        },
        openUpdateModal() {
            this.isUpdateModalVisible = true;
        },
        closeUpdateModal() {
            this.isUpdateModalVisible = false;
        },
        openDeleteModal() {
            this.isDeleteModalVisible = true;
        },
        closeDeleteModal() {
            this.isDeleteModalVisible = false;
        },
        openTerminateModal() {
            this.isTerminateModalVisible = true;
        },
        closeTerminateModal() {
            this.isTerminateModalVisible = false;
        },
        openSickDaysModal(contractId, employeeName){
            this.sickDaysOptions.contractId = contractId;
            this.sickDaysOptions.employeeName = employeeName;
            this.isSickDaysModalVisible = true;
        },
        closeSickDaysModal(){
            this.isSickDaysModalVisible = false;
        },
        showUsers() {
            if (this.userFilter === "all") {
                return true;
            }
            return false;
        },
        sendSickDaysSummary(){
            if(confirm('Möchtest Du die Übersicht der Kranheitstage aller Mitarbeiter per Email versenden?') == true){
                apiService.post(`/Internal/SendSickDaysSummaryByUserRequest`)
                    .then(() => {
                        console.log("Versand ausgelöst!");
                    })
                    .catch(error => {
                        console.log("Error on sending sick days summary! Error: " + error);
                    });
            }
            else{
                console.log("Nicht versendet!");
            }
        }
    },
    computed: {
        filteredContracts() {
            return this.filterContracts();
        },
    },
};
</script>
<style>
.container-admin {
    display: flex;
    flex-direction: column;
    gap: 1rem
}

.button-footer button {
    margin-left: 5px;
}

.button-footer button:hover {
    cursor: pointer;
    background-color: #c0c0c0;
}

.contract-button{
    display: flex;
    align-items: right;
}
</style>